import React from "react";

const APP = React.createContext();

export default APP;
